var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetaTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 19,
    viewBox: "0 0 43 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.43164,
    width: 42,
    height: 17,
    rx: 8.5,
    fill: "#452107"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.43164,
    width: 42,
    height: 17,
    rx: 8.5,
    stroke: "url(#paint0_linear_12589_79745)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09141 5.50764H10.7514C11.6074 5.50764 12.2874 5.71564 12.7914 6.13164C13.3034 6.54764 13.5594 7.07564 13.5594 7.71564C13.5594 8.66764 13.0034 9.31164 11.8914 9.64764C12.4594 9.72764 12.9114 9.96364 13.2474 10.3556C13.5834 10.7476 13.7514 11.2076 13.7514 11.7356C13.7514 12.4076 13.5034 12.9436 13.0074 13.3436C12.5194 13.7356 11.8354 13.9316 10.9554 13.9316H7.09141V5.50764ZM9.14341 7.06764V8.89164H10.4874C10.7834 8.89164 11.0194 8.81564 11.1954 8.66364C11.3794 8.51164 11.4714 8.28764 11.4714 7.99164C11.4714 7.68764 11.3794 7.45964 11.1954 7.30764C11.0194 7.14764 10.7834 7.06764 10.4874 7.06764H9.14341ZM9.14341 12.3716H10.6914C10.9714 12.3716 11.2034 12.2876 11.3874 12.1196C11.5714 11.9516 11.6634 11.7196 11.6634 11.4236C11.6634 11.1276 11.5754 10.8916 11.3994 10.7156C11.2234 10.5396 10.9954 10.4516 10.7154 10.4516H9.14341V12.3716ZM20.2773 5.48364V7.04364H17.2293V8.85564H19.9173V10.4156H17.2293V12.3716H20.2773V13.9316H15.1773V5.48364H20.2773ZM21.4685 7.06764V5.50764H28.1165V7.06764H25.8125V13.9316H23.7605V7.06764H21.4685ZM34.6973 13.9316L34.2293 12.5156H31.2053L30.7373 13.9316H28.5533L31.4813 5.48364H33.9773L36.8933 13.9316H34.6973ZM31.7213 10.9556H33.7133L32.7173 7.95564L31.7213 10.9556Z",
    fill: "#F7F7F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12589_79745",
    x1: 0,
    y1: 9.93164,
    x2: 29.6843,
    y2: 9.93164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF0963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7D04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaTag);
export default __webpack_public_path__ + "static/media/beta-tag.35480c67aa6e6a42c3b29ba3136245cd.svg";
export { ForwardRef as ReactComponent };